/* global slideUp, slideDown, localData */

// **************************************************
// Quiz question
// **************************************************
const quizQuestions = document.querySelectorAll('.quiz-question');
const quizResults = {
  stepsAnswered: {},
  stepAnswer: (index, correct) => {
    const ind = index.replace('quiz-step-', '');
    if (typeof quizResults.stepsAnswered[ind] === 'undefined') {
      quizResults.stepsAnswered[ind] = correct ? 1 : 0;

      // if last question
      if (parseInt(ind, 10) === 10) {
        let sum = 0;
        Object.keys(quizResults.stepsAnswered).forEach((key) => {
          sum += quizResults.stepsAnswered[key];
        });

        const resultNum = sum > 8 ? 1 : sum > 4 ? 2 : 3;
        const banner = document.querySelector('.congratulations-banner[data-result="'+ resultNum +'"]');
        banner.classList.remove('d-xs-none');

        // save result
        const request = new XMLHttpRequest();
        request.open('POST', localData.siteURL, true);
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        request.send(`action=sendResultQuiz&result=${sum}`);

        // social icons
        document.querySelectorAll('.soc-med-icon').forEach((icon) => {
          const type = icon.getAttribute('data-social-type');
          const basicHref = icon.getAttribute('href');
          const bannerText = banner.querySelector('.body-text').textContent;
          const bannerTitle = banner.querySelector('.title').textContent;

          switch (type) {
            case 'facebook':
              icon.setAttribute(
                'href',
                `${basicHref + encodeURIComponent(`${window.location.href}?result=${resultNum}`)}`
              );
              break;
            case 'twitter':
              icon.setAttribute(
                'href',
                `${basicHref + encodeURIComponent(`${window.location.href}?result=${resultNum}`)}&text=${encodeURIComponent(bannerText)}`
              );
              break;
            case 'linkedin':
              icon.setAttribute(
                'href',
                `${basicHref + encodeURIComponent(`${window.location.href}`)}&title=${encodeURIComponent(bannerTitle)}&summary=${encodeURIComponent(bannerText)}`
              );
              break;
            default:
              console.log('Unknown social icon type');
              break;
          }
        });
      }
    }
  },
};

quizQuestions.forEach((quizQuestion) => {
  quizQuestion.querySelectorAll('.radio-button__label').forEach((radio) => {
    radio.addEventListener('click', (event) => {
      // make variables inside click function, so that garbage collection deletes them
      const isCorrect = event.target.closest('.radio-button__label').classList.contains('correct');
      const question = event.target.closest('.quiz-question');
      const failed = question.querySelector('.quiz-question__failed');
      const success = question.querySelector('.quiz-question__success');

      if (!isCorrect && !failed.classList.contains('is-active')) {
        slideUp(success, 300);
        success.classList.remove('is-active');
        failed.classList.add('is-active');
        slideDown(failed, 300);
        quizResults.stepAnswer(question.getAttribute('data-step'), isCorrect);
      } else if (isCorrect && !success.classList.contains('is-active')) {
        slideUp(failed, 300);
        failed.classList.remove('is-active');
        success.classList.add('is-active');
        slideDown(success, 300);
        quizResults.stepAnswer(question.getAttribute('data-step'), isCorrect);
      }
    });
  });
});
